export interface Segmentation {
  uuid: string;
  icid: string;
  fileUrl: string;
  paths: string[];
}
export interface Frame {
  uuid: string;
  icid: string;
  fileUrl: string;
  index: number;
}

export interface Dicom {
  uuid: string;
  icid: string;
  foreignId?: string;
}

export interface Study {
  uuid: string;
  icid: string;
  foreignId?: string;
}

export interface ReviewResponse {
  uuid: string;
  decision: string;
  comment: string;
  reviewedBy: string;
  reviewedObjectUuid: string;
  relatedObjectUuid: string;
}

export interface Label {
  icid: string;
  uuid: string;
  fileUrl: string;
  paths: string[];
  review?: ReviewResponse;
}

export interface Prediction {
  fileUrl: string;
  paths: string[];
  uuid: string;
  icid: string;
  review?: ReviewResponse;
  source_uuid?: string;
  source_type?: string;
  // camelCase variants returned by backend in some endpoints
  sourceUuid?: string;
  sourceType?: string;
}

export interface SegmentationPair {
  label: Segmentation | null;
  prediction: Segmentation | null;
}

export interface SegmentationPredictionToCompare {
  segmentationClass: string;
  frame: Frame;
  dicom: Dicom;
  study: Study;
  label: Label;
  prediction: Prediction;
  segmentationA: Label | null;
  segmentationB: Label | null;
  isApproved: boolean;
  isRejected: boolean;
  isReviewed: boolean;
  isAcceptAi: boolean;
  isAcceptHuman: boolean;
  isAcceptBoth: boolean;
  isAcceptNeither: boolean;
  reviewUuid?: string;
  reviewedBy?: string;
  reviewDecision?: string;
  reviewComment?: string;
  // Top-level source provenance returned by blinded endpoint
  source_uuid?: string;
  source_type?: string;
  // camelCase variants
  sourceUuid?: string;
  sourceType?: string;
}

export interface SegmentationPredictionComparisonResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: SegmentationPredictionToCompare[];
  stats: {
    totalFound: number;
    accepted: number;
    rejected: number;
    acceptAi: number;
    acceptHuman: number;
    acceptBoth: number;
    acceptNeither: number;
    toBeReviewed: number;
  };
}

export enum ReviewDecision {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  ACCEPT_AI = 'ACCEPT_AI',
  ACCEPT_HUMAN = 'ACCEPT_HUMAN',
  ACCEPT_BOTH = 'ACCEPT_BOTH',
  ACCEPT_NEITHER = 'ACCEPT_NEITHER',
}

export interface FrameWithLabelAndPredictionParams {
  page?: number;
  size?: number;
  is_reviewed?: boolean;
  review_decision?: ReviewDecision;
  has_corresponding_label?: boolean;
  features?: { uuid: string; name: string }[];
  datasource?: { uuid: string; name: string };
  dicom_icid?: string;
  source_uuid?: string;
  study_icid?: string;
  study_fid?: string;
  created_at_after?: string;
  created_at_before?: string;
  label_created_at_after?: string;
  label_created_at_before?: string;
  blinded?: boolean;
}
